import type { Gradient } from '@jouzen/ecom-components';

const heartHealthHeroGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#B38A8A',
    id: 'rose-1',
    position: [10, 0],
    opacity: 0.4,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#B38A8A',
    id: 'rose-2',
    position: [99, 40],
    opacity: 0.5,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#B38A8A',
    id: 'rose-3',
    position: [25, 99],
    opacity: 0.4,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#D7E2E8',
    id: 'blue-1',
    position: [99, 70],
    opacity: 0.7,
    size: 20,
  },
];

export default heartHealthHeroGradients;
